// ModalForm.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './ModalForm.css';

/**
 * ModalForm
 * 
 * A simple form component for modals.
 *  
 * @param {string} height - The height of the form.
 * @param {string} gap - The gap between form elements.
 * @param {string} children - The children to display inside the form.
 * 
 * @returns {ReactNode} - ModalForm.
 */
const ModalForm = React.memo(({ height = 'auto', gap = '24px', children }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <div
            className="modal-form-container"
            style={{
                color: theme.foregroundMuted,
                height: height,
                gap: gap,
            }}
        >
            {children}
        </div>
    );

});

// Dev Tools
ModalForm.displayName = 'ModalForm';

export default ModalForm;

